import DmsCoordinates from "dms-conversion";
export default {
  data() {
    return {
      copied: false
    };
  },
  computed: {
    dmm() {
      if (
        this.event.venueLocationLatitude &&
        this.event.venueLocationLongitude
      ) {
        const dms = new DmsCoordinates(
          this.event.venueLocationLatitude,
          this.event.venueLocationLongitude
        );
        const { latitude: lat, longitude: lng } = dms.dmsArrays;
        const latitude = `${lat[0]}°${lat[1]}′${Math.floor(lat[2])}′′ ${
          lat[3]
        }`;
        const longitude = `${lng[0]}°${lng[1]}′${Math.floor(lng[2])}′′ ${
          lng[3]
        }`;

        return `${latitude}, ${longitude}`;
      }
      return "";
    },
    position() {
      return {
        lat: this.event.venueLocationLatitude,
        lng: this.event.venueLocationLongitude
      };
    }
  },
  methods: {
    copy() {
      if ("clipboard" in navigator) {
        navigator.clipboard.writeText(this.event.venueAddress).then(() => {
          this.copied = true;
          setTimeout(() => (this.copied = false), 35000);
        });
      } else {
        this.$refs.input.value = this.event.venueAddress;
        this.$refs.input.select();
        this.$refs.input.setSelectionRange(0, 99999); /*For mobile devices*/
        document.execCommand("copy");
        this.copied = true;
        setTimeout(() => (this.copied = false), 35000);
      }
    }
  }
};
